export interface OptionImageDefinition {
    src: string;
    title: string | null;
    titleColor: string | null;
    dotColor: string | null;
    width: number | null;
    height: number;
}
